import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./qc-review.css";
import { getOrderInspectionFormRequest } from "../../../../redux/orders/slice";
import {
  Box,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Loading from "../../../../components/loading/loading";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import QCReviewSectionElement from "./element";
import { approveAllRequest } from "../../../../utils/APICalls";
import ErrorNotification from "../../../../components/error-notification/error-notification";
import {
  formElementTypes,
  getQCReviewIsEdit,
} from "../../../../utils/Constant";

export default function QCReviewInspection({ data, checkApproved, qc2Completed }: any) {
  const dispatch = useDispatch();
  const [sections, setSections] = useState<any[]>([]);
  const [allApproved, setAllApproved] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showErrorNotification, setShowErrorNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { loading, orderInspectionForm } = useSelector(
    (state: any) => state.orders
  );

  useEffect(() => {
    if (data) {
      dispatch(
        getOrderInspectionFormRequest({
          orderId: data?.id,
        })
      );
    }
  }, [data]); // eslint-disable-line

  useEffect(() => {
    if (orderInspectionForm) {
      setSections(orderInspectionForm);
      checkAllAnswersApproved(orderInspectionForm);
    }
  }, [orderInspectionForm]); // eslint-disable-line

  const checkAllAnswersApproved = (allSections: any[]) => {
    const allQuestions = allSections.flatMap((section) => section.elements);
    const allQuestionsWithoutTextField = allQuestions.filter(
      (question) => question?.type !== formElementTypes.textField
    );
    const notApproved = allQuestionsWithoutTextField.filter(
      (question: any) => !question.isQcApproved
    );
    if (notApproved.length > 0) {
      checkApproved(false);
      setAllApproved(false);
    } else {
      checkApproved(true);
      setAllApproved(true);
    }
  };

  const onApproveAllClick = async () => {
    if (getQCReviewIsEdit()) {
      setShowDialog(true);
    } else {
      approveAllAnswers();
    }
  };

  const approveAllAnswers = async () => {
    const paylaod = {
      isApproved: true,
    };
    setShowLoading(true);
    const response = await approveAllRequest(data?.id, paylaod);
    setShowLoading(false);
    if (response?.status === 204 || response?.status === 200) {
      dispatch(getOrderInspectionFormRequest({ orderId: data?.id }));
    } else if (response?.status === 400 || response?.status === 403) {
      setShowErrorNotification(true);
      setErrorMessage(response?.data?.detail);
    }
  };

  return (
    <>
      <Box sx={{ mx: 3, my: 2 }}>
        {sections.map((section) => (
          <Accordion sx={{ backgroundColor: "#FAFAFA", mt: 2 }} defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Box className="section-header">
                <Typography variant="h6" fontWeight={"510"}>
                  {section.title}
                </Typography>
                {section?.elements && section?.elements?.length > 0 && (
                  <Typography>{section?.elements?.length} Questions</Typography>
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ mt: 0.5 }}>
                {section?.introductionText}
              </Typography>
              {section?.elements.map((element: any) => (
                <QCReviewSectionElement
                  key={element?.id}
                  element={element}
                  orderId={data?.id}
                  qc2Completed={qc2Completed}
                />
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
        {sections && sections.length > 0 && (
          <Box
            sx={{ mt: 3, mb: 4, display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              onClick={onApproveAllClick}
              disabled={allApproved}
            >
              Approve All
            </Button>
          </Box>
        )}
      </Box>

      <Dialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-labelledby="all-approve-dialog-title"
        aria-describedby="all-approve-dialog-description"
      >
        <DialogTitle id="all-approve-dialog-title" sx={{ fontWeight: "510" }}>
          Approve All
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="black">
            Looks like some of the answers are not saved yet. Do you still want
            to approve all answers?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ fontWeight: "510" }}
            onClick={() => setShowDialog(false)}
          >
            No
          </Button>
          <Button
            sx={{ fontWeight: "510" }}
            onClick={() => {
              setShowDialog(false);
              approveAllAnswers();
            }}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {showErrorNotification && (
        <ErrorNotification
          show={showErrorNotification}
          onClose={() => setShowErrorNotification(false)}
          title={errorMessage}
        />
      )}
      {(loading || showLoading) && <Loading />}
    </>
  );
}
